import { render, staticRenderFns } from "./ReservationAccommodationResolveForm.vue?vue&type=template&id=07db15cb&scoped=true&"
import script from "./ReservationAccommodationResolveForm.vue?vue&type=script&lang=js&"
export * from "./ReservationAccommodationResolveForm.vue?vue&type=script&lang=js&"
import style0 from "./ReservationAccommodationResolveForm.vue?vue&type=style&index=0&id=07db15cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db15cb",
  null
  
)

export default component.exports